import { todayAutofill } from "./GlobalFunc";

export let menulist = [
  {
    keyIndex: 1,
    link: "/dashboard",
    routerName: "dashboard",
    name: "Dashboard",
    icon: "grid",
    is_super: false,
    isShow: "isAll",
  },
  {
    keyIndex: 33,
    link: "/opportunities?page=1&size=100",
    routerName: "opportunity",
    name: "Opportunity",
    icon: "compass",
    is_super: false,
    isShow: "is_lead",
  },
  {
    keyIndex: 34,
    link: `/alerts?and_notify_at__date=${todayAutofill()}&page=1&size=100`,
    routerName: "alerts",
    name: "Opportunity Task",
    icon: "bell",
    is_super: false,
    isShow: "is_lead",
  },
  {
    keyIndex: 12,
    link: "/contacts?page=1&size=100",
    routerName: "contact",
    name: "Contacts",
    icon: "users",
    is_super: false,
    isShow: "is_lead",
  },
  {
    keyIndex: 13,
    link: "/companies/customer?page=1&size=100&ordering=name",
    routerName: "company",
    name: "Companies",
    icon: "globe",
    is_super: false,
    isShow: "is_lead",
  },
  {
    keyIndex: 27,
    link: "/media?page=1&size=100",
    routerName: "media",
    icon: "image",
    name: "Media",
    is_super: false,
    isShow: "is_lead",
  },
  {
    keyIndex: 3,
    link: "/marketing/leads?page=1&size=100",
    routerName: "marketing",
    name: "Marketing",
    icon: "volume-2",
    is_super: false,
    isShow: "is_marketing",
  },
  {
    keyIndex: 4,
    link: "/proposals?page=1&size=100",
    routerName: "proposals",
    name: "Proposal",
    icon: "clipboard",
    is_super: false,
    isShow: "is_proposal",
  },
  {
    keyIndex: 5,
    link: "/invoices?page=1&size=100",
    routerName: "invoices",
    name: "Invoices",
    icon: "file-text",
    is_super: false,
    isShow: "is_invoice",
  },
  {
    keyIndex: 11,
    link: "/payments?page=1&size=100",
    routerName: "payments",
    name: "Payments",
    icon: "dollar-sign",
    is_super: false,
    isShow: "is_invoice",
  },
  {
    submenuKey: "sub1",
    subMenuTitle: "Inventory",
    subMenIcon: "codesandbox",
    is_super: false,
    isShow: "is_inventory",
    subMenuList: [
      {
        keyIndex: 6,
        link: "/supplier?page=1&size=100",
        routerName: "supplier",
        icon: "users",
        name: "Supplier",
      },
      {
        keyIndex: 7,
        link: "/inventory?page=1&size=100",
        routerName: "inventory",
        icon: "codesandbox",
        name: "Inventory",
      },
      {
        keyIndex: 8,
        link: "/purchase-order-list?page=1&size=100",
        routerName: "purchase order list",
        icon: "shopping-cart",
        name: "Purchase Orders",
      },
    ],
  },
  {
    keyIndex: 9,
    link: "/shipping?and_status=pending&page=1&size=100&ordering=expected_delivery_date",
    routerName: "shipping",
    icon: "truck",
    name: "Shipping",
    is_super: false,
    isShow: "is_shipping",
  },
  {
    keyIndex: 17,
    link: "/installation?page=1&size=100",
    routerName: "Installation",
    icon: "link",
    name: "Installation",
    is_super: false,
    isShow: "is_installation",
  },
  {
    keyIndex: 18,
    link: "/subscription?page=1&size=100",
    routerName: "Subscription",
    icon: "briefcase",
    name: "Subscription",
    is_super: false,
    isShow: "is_subscription",
  },
  {
    keyIndex: 10,
    link: "/porting?page=1&size=100",
    routerName: "porting",
    name: "Porting",
    icon: "git-pull-request",
    is_super: false,
    isShow: "is_porting",
  },
  {
    keyIndex: 19,
    link: "/tickets?page=1&size=100",
    routerName: "tickets",
    name: "Tickets",
    icon: "inbox",
    is_super: false,
    isShow: "is_ticket",
  },
  {
    keyIndex: 30,
    link: "/tasks?page=1&and_status=scheduled&size=100",
    routerName: "Tasks",
    name: "Tasks",
    icon: "check-square",
    is_super: false,
    isShow: "is_marketing",
  },
  {
    keyIndex: 2,
    link: "/reports",
    routerName: "reports",
    name: "Reports",
    icon: "trello",
    is_super: false,
    isShow: "isAll",
  },
  {
    keyIndex: 24,
    link: "/map",
    routerName: "map",
    icon: "map-pin",
    name: "Map",
    is_super: false,
    isShow: "isAll",
  },
  {
    keyIndex: 29,
    link: "/bulk-mail?page=1&size=100",
    routerName: "bulk mail",
    icon: "mail",
    name: "Bulk Mail",
    is_super: false,
    isShow: "isAll",
  },
  // {
  //   keyIndex: 28,
  //   link: "/event-lead/leads?page=1&size=100",
  //   routerName: "Event-Lead",
  //   icon: "list",
  //   name: "Event Leads",
  //   is_super: false,
  //   isShow: "isAll",
  // },
  {
    keyIndex: 14,
    link: "/settings",
    routerName: "settings",
    name: "Settings",
    icon: "settings",
    is_super: false,
    isShow: "is_settings",
  },
  {
    keyIndex: 21,
    link: "/super-dashboard",
    routerName: "Super dashboard",
    icon: "grid",
    name: "Dashboard",
    is_super: true,
  },
  {
    keyIndex: 16,
    link: "/adminaccount",
    routerName: "account",
    icon: "book",
    name: "CRM Accounts",
    is_super: true,
  },
  {
    keyIndex: 15,
    link: "/admin",
    routerName: "admin",
    icon: "users",
    name: "Admin Users",
    is_super: true,
  },
  {
    keyIndex: 25,
    link: "/reseller-account",
    routerName: "Reseller Accounts",
    icon: "book-open",
    name: "Reseller Accounts",
    is_super: true,
  },
  {
    keyIndex: 26,
    link: "/reseller",
    routerName: "Reseller",
    icon: "user-check",
    name: "Reseller Users",
    is_super: true,
  },
  {
    keyIndex: 20,
    link: "/ticket-titles",
    routerName: "ticket titles",
    icon: "headphones",
    name: "Ticket Titles",
    is_super: true,
  },
  {
    keyIndex: 32,
    link: "/lead-source",
    routerName: "Lead Source",
    icon: "database",
    name: "Lead Source",
    is_super: true,
  },
  {
    keyIndex: 31,
    link: "/ticket-departments",
    routerName: "Ticket Departments",
    icon: "briefcase",
    name: "Ticket Departments",
    is_super: true,
  },
  {
    keyIndex: 22,
    link: "/quickbook-connection",
    routerName: "Quickbook Connection",
    icon: "book",
    name: "Quickbook",
    is_super: true,
  },
  {
    keyIndex: 23,
    link: "/user-permission",
    routerName: "user-permission",
    icon: "shield",
    name: "Permissions",
    is_super: true,
  },
];

// Last index 34
